export enum MarketingConsentType {
    PHONE = "phone_marketing_consent",
    EMAIL = "email_marketing_consent",
    CPL = "can_receive_cpl_campaigns"
}

export type Subscription = {
    name: MarketingConsentType;
    title: string;
    text: string;
    onConsentChange?: (checked: boolean) => void;
};

export const marketingConsents: Subscription[] = [
    {name: MarketingConsentType.PHONE, title: "SMS", text: "Chcę otrzymywać SMS-em powiadomienia o najnowszych ofertach i promocjach"},
    {name: MarketingConsentType.EMAIL, title: "E-mail", text: "Chcę otrzymywać informacje o najnowszych ofertach i promocjach na moją skrzynkę e-mail"}
];

export enum HomeMatchConsentType {
    HM = "is_active"
}
export enum MarketingConsentType {
    PHONE = "phone_marketing_consent",
    EMAIL = "email_marketing_consent",
    CPL = "can_receive_cpl_campaigns"
}

export type Subscription = {
    name: MarketingConsentType;
    title: string;
    text: string;
    onConsentChange?: (checked: boolean) => void;
};

export const marketingConsents: Subscription[] = [
    {name: MarketingConsentType.PHONE, title: "SMS", text: "Chcę otrzymywać SMS-em powiadomienia o najnowszych ofertach i promocjach"},
    {name: MarketingConsentType.EMAIL, title: "E-mail", text: "Chcę otrzymywać informacje o najnowszych ofertach i promocjach na moją skrzynkę e-mail"}
];

export enum HomeMatchConsentType {
    HM = "is_active"
}
